import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent} from '../login/login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MFACodeComponent } from './mfa-code/mfa-code.component';
import { ForgotUsernameComponent } from './forgot-username/forgot-username.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  ,
  {
    path: 'forgot-username',
    component: ForgotUsernameComponent
  },
  {
    path: 'mfa-code',
    component: MFACodeComponent
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
